var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-row",
            {
              staticClass: "predmet-form__info mobile-flex-direction",
              attrs: { "no-gutters": "" }
            },
            [
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "0", "order-md": "0" } },
                [
                  _c("dynamic-combo", {
                    key: "liw_filip__wiz_predmet__cb_typ_predmetu",
                    ref: "typ_predmetu",
                    attrs: {
                      returnObject: true,
                      "data-id": "liw_filip__wiz_predmet__cb_typ_predmetu",
                      cisloPredmetu: _vm.cisloPredmetu,
                      outlined: ""
                    },
                    on: { valueChanged: _vm.onTypPredmetuValueChaged },
                    model: {
                      value: _vm.typPredmetuItem,
                      callback: function($$v) {
                        _vm.typPredmetuItem = $$v
                      },
                      expression: "typPredmetuItem"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "3", "order-md": "0" } },
                [
                  _c("dodavatel", {
                    key: "liw_filip__wiz_predmet__cb_dodavatel",
                    ref: "dodavatel",
                    attrs: {
                      "data-id": "liw_filip__wiz_predmet__cb_dodavatel",
                      cisloPredmetu: _vm.cisloPredmetu
                    },
                    on: { valueChanged: _vm.onDodavatelValueChanged },
                    model: {
                      value: _vm.dodavatel,
                      callback: function($$v) {
                        _vm.dodavatel = $$v
                      },
                      expression: "dodavatel"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "5", "order-md": "0" } },
                [
                  _c("sprostredkovatel", {
                    key: "liw_filip__wiz_predmet__cb_sprostredkovatel",
                    ref: "sprostredkovatel",
                    attrs: {
                      optional: "",
                      "data-id": "liw_filip__wiz_predmet__cb_sprostredkovatel",
                      cisloPredmetu: _vm.cisloPredmetu
                    },
                    on: { valueChanged: _vm.onSprostredkovatelValueChanged }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "1", "order-md": "0" } },
                [
                  _c("dynamic-combo", {
                    key: "liw_filip__wiz_predmet__cb_druh_tovaru",
                    ref: "druhTovaru",
                    attrs: {
                      "data-id": "liw_filip__wiz_predmet__cb_druh_tovaru",
                      cisloPredmetu: _vm.cisloPredmetu
                    },
                    on: { valueChanged: _vm.onDruhTovaruValueChanged }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "4", "order-md": "0" } },
                [
                  _c("dynamic-combo", {
                    key: "liw_filip__wiz_predmet__cb_predajca_dodavatela",
                    ref: "predajca_dodavatela",
                    attrs: {
                      optional: "",
                      "data-id":
                        "liw_filip__wiz_predmet__cb_predajca_dodavatela",
                      clearable: "",
                      cisloPredmetu: _vm.cisloPredmetu
                    },
                    on: { valueChanged: _vm.onPredajcaDodavatelaValueChanged }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "6", "order-md": "0" } },
                [
                  _c("dynamic-combo", {
                    key:
                      "liw_filip__wiz_predmet__cb_predajca_sprostredkovatela",
                    ref: "predajca_sprostredkovatela",
                    attrs: {
                      optional: "",
                      "data-id":
                        "liw_filip__wiz_predmet__cb_predajca_sprostredkovatela",
                      clearable: "",
                      cisloPredmetu: _vm.cisloPredmetu
                    },
                    on: {
                      valueChanged: _vm.onPredajcaSprostredkovatelaValueChanged
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "9", "order-md": "0" } },
                [
                  _c("dynamic-combo", {
                    key: "liw_filip__wiz_predmet__cb_znacky",
                    ref: "znacka",
                    attrs: {
                      "data-id": "liw_filip__wiz_predmet__cb_znacky",
                      cisloPredmetu: _vm.cisloPredmetu,
                      outlined: ""
                    },
                    on: {
                      valueChanged: _vm.onZnackaValueChanged,
                      dataLoaded: function($event) {
                        return _vm.$refs.nazovPredmetu.loadData()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "9", "order-md": "0" } },
                [
                  _c("dynamic-combo", {
                    key: "liw_filip__wiz_predmet__cb_modely",
                    ref: "modely",
                    attrs: {
                      "data-id": "liw_filip__wiz_predmet__cb_modely",
                      cisloPredmetu: _vm.cisloPredmetu,
                      outlined: ""
                    },
                    on: { valueChanged: _vm.onModelyValueChanged }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "9", "order-md": "0" } },
                [
                  _c("dynamic-combo", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.jeTechnologia,
                        expression: "!jeTechnologia"
                      }
                    ],
                    key: "liw_filip__wiz_predmet__cb_modely_verzie",
                    ref: "modely_verzie",
                    attrs: {
                      clearable: "",
                      "data-id": "liw_filip__wiz_predmet__cb_modely_verzie",
                      cisloPredmetu: _vm.cisloPredmetu,
                      "fulltext-filter": ""
                    },
                    on: { valueChanged: _vm.onModelyVerzieValueChanged }
                  }),
                  _c("text-box", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.jeTechnologia,
                        expression: "jeTechnologia"
                      }
                    ],
                    ref: "nazovPredmetu",
                    attrs: {
                      label: "Názov predmetu",
                      cisloPredmetu: _vm.cisloPredmetu,
                      "data-id": "liw_filip__wiz_predmet__txt_nazov_predmetu"
                    }
                  })
                ],
                1
              ),
              !_vm.jeTechnologia
                ? [
                    _c(
                      "v-col",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isControlVisible(
                              "vyrobne_cislo",
                              "liw_filip__wiz_predmet__txt_vyrobne_cislo"
                            ),
                            expression:
                              "isControlVisible('vyrobne_cislo','liw_filip__wiz_predmet__txt_vyrobne_cislo')"
                          }
                        ],
                        attrs: {
                          md: "4",
                          sm: "12",
                          order: "10",
                          "order-md": "0"
                        }
                      },
                      [
                        _c("text-box", {
                          key: "liw_filip__wiz_predmet__txt_vyrobne_cislo",
                          ref: "vyrobne_cislo",
                          attrs: {
                            parentReloaded: _vm.reloaded,
                            "data-id":
                              "liw_filip__wiz_predmet__txt_vyrobne_cislo",
                            cisloPredmetu: _vm.cisloPredmetu,
                            loading: _vm.vinLoading,
                            optional: "",
                            rules: [_vm.vinRule]
                          },
                          on: {
                            valueChanged: function(val) {
                              return _vm.onVyrobneCisloChanged(val, true)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          md: "4",
                          sm: "12",
                          order: "10",
                          "order-md": "0"
                        }
                      },
                      [
                        _c("DatePicker", {
                          key:
                            "liw_filip__wiz_predmet__txt_datum_1_registracie",
                          ref: "datum_1_registracie",
                          attrs: {
                            label: "Dátum prvej registrácie",
                            placeholder: "DD/MM/YYYY",
                            "data-id":
                              "liw_filip__wiz_predmet__txt_datum_1_registracie",
                            cisloPredmetu: _vm.cisloPredmetu,
                            max: _vm.formatDate(new Date())
                          },
                          on: {
                            valueChanged: _vm.onDatum1RegistracieValueChanged,
                            dataLoaded: _vm.onDatum1RegistracieDataLoaded
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          md: "4",
                          sm: "12",
                          order: "10",
                          "order-md": "0"
                        }
                      },
                      [
                        _c("numeric-text-box", {
                          key: "liw_filip__wiz_predmet__txt_pocet_km",
                          ref: "pocet_km",
                          attrs: {
                            "data-id": "liw_filip__wiz_predmet__txt_pocet_km",
                            cisloPredmetu: _vm.cisloPredmetu,
                            suffix: "km",
                            decimalPlaces: 0,
                            textRight: false
                          },
                          on: { valueChanged: _vm.onPocetKmValueChanged }
                        })
                      ],
                      1
                    )
                  ]
                : [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          md: "4",
                          sm: "12",
                          order: "10",
                          "order-md": "0"
                        }
                      },
                      [
                        _c("text-box", {
                          key: "liw_filip__wiz_predmet_tech__txt_vyrobne_cislo",
                          attrs: {
                            parentReloaded: _vm.reloaded,
                            "data-id":
                              "liw_filip__wiz_predmet_tech__txt_vyrobne_cislo",
                            cisloPredmetu: _vm.cisloPredmetu,
                            rules: [_vm.vinRule]
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          md: "4",
                          sm: "12",
                          order: "10",
                          "order-md": "0"
                        }
                      },
                      [
                        _c("numeric-text-box", {
                          key: "liw_filip__wiz_predmet_tech__txt_rok_vyroby",
                          ref: "rok_vyroby",
                          attrs: {
                            parentReloaded: _vm.reloaded,
                            "data-id":
                              "liw_filip__wiz_predmet_tech__txt_rok_vyroby",
                            cisloPredmetu: _vm.cisloPredmetu,
                            decimalPlaces: 0,
                            textRight: false,
                            format: false,
                            maxValue: parseInt(new Date().getFullYear()) + 1
                          },
                          on: {
                            valueChanged: _vm.onRokVyrobyValueChanged,
                            dataLoaded: function() {
                              _vm.$refs.rokVyrobyAuto.loadData()
                              _vm.$refs.vekPredmetuAuto.loadData()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          md: "4",
                          sm: "12",
                          order: "10",
                          "order-md": "0"
                        }
                      },
                      [
                        _c("numeric-text-box", {
                          key: "liw_filip__wiz_predmet_tech__txt_pocet_mh",
                          ref: "pocet_mh",
                          attrs: {
                            parentReloaded: _vm.reloaded,
                            "data-id":
                              "liw_filip__wiz_predmet_tech__txt_pocet_mh",
                            cisloPredmetu: _vm.cisloPredmetu,
                            suffix: "mth",
                            decimalPlaces: 0,
                            textRight: false
                          },
                          on: { valueChanged: _vm.onPocetMhValueChanged }
                        })
                      ],
                      1
                    )
                  ],
              !_vm.jeTechnologia
                ? [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          md: "4",
                          sm: "12",
                          order: "11",
                          "order-md": "0"
                        }
                      },
                      [
                        _c("text-box", {
                          key: "liw_filip__wiz_predmet__txt_ecv_povodne",
                          ref: "ecv",
                          attrs: {
                            parentReloaded: _vm.reloaded,
                            "data-id":
                              "liw_filip__wiz_predmet__txt_ecv_povodne",
                            cisloPredmetu: _vm.cisloPredmetu,
                            loading: _vm.ecvLoading
                          },
                          on: {
                            valueChanged: function(val) {
                              return _vm.onECVChanged(val, true)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("v-col", {
                      attrs: { md: "4", order: "0", "order-md": "0" }
                    }),
                    _c("v-col", {
                      attrs: { md: "4", order: "11", "order-md": "0" }
                    })
                  ]
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { md: "4", sm: "12", order: "12", "order-md": "0" } },
                [
                  _c("dynamic-combo", {
                    key: "liw_filip__wiz_predmet__cb_sposob_pouzitia",
                    ref: "sposob_pouzitia",
                    attrs: {
                      "data-id": "liw_filip__wiz_predmet__cb_sposob_pouzitia",
                      cisloPredmetu: _vm.cisloPredmetu,
                      outlined: "",
                      clearable: true
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticStyle: { "align-self": "center" },
                  style: _vm.isMobile ? null : { marginTop: "-12px" },
                  attrs: { md: "4", sm: "12", order: "12", "order-md": "0" }
                },
                [
                  _c("button-group", {
                    key: "liw_filip__wiz_predmet__btn_ojazdene_vozidlo",
                    ref: "ojazdene_vozidlo",
                    attrs: {
                      switchBtn: "",
                      small: "",
                      "data-id": "liw_filip__wiz_predmet__btn_ojazdene_vozidlo",
                      cisloPredmetu: _vm.cisloPredmetu
                    },
                    on: { valueChanged: _vm.onOjazdeneVozidloValueChanged }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticStyle: { "align-self": "center" },
                  style: _vm.isMobile
                    ? { marginTop: "8px" }
                    : { marginTop: "-12px" },
                  attrs: { md: "4", sm: "12", order: "12", "order-md": "0" }
                },
                [
                  _c("button-group", {
                    key: "liw_filip__wiz_predmet__btn_alternativny_predmet",
                    ref: "alternativny_predmet",
                    attrs: {
                      switchBtn: "",
                      small: "",
                      "data-id":
                        "liw_filip__wiz_predmet__btn_alternativny_predmet",
                      cisloPredmetu: _vm.cisloPredmetu
                    },
                    on: {
                      valueChanged: function(val) {
                        return _vm.onAlternativnyPredemet(val)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { md: "12", sm: "12", order: "0", "order-md": "0" } },
                [
                  _c("check-box", {
                    key: "liw_filip__wiz_predmet__btn_podlieha_evidencii_di",
                    ref: "podlieha_evidencii_di",
                    attrs: {
                      parentReloaded: _vm.reloaded,
                      "data-id":
                        "liw_filip__wiz_predmet__btn_podlieha_evidencii_di",
                      cisloPredmetu: _vm.cisloPredmetu
                    }
                  })
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "predmet-form__rozsirene-moznosti",
              attrs: { "no-gutters": "" }
            },
            [
              _c(
                "v-expansion-panels",
                {
                  staticClass: "wizard-expansion-panels px-1",
                  class: [
                    {
                      "mb-5": !_vm.isMobile,
                      "mb-3": _vm.isMobile
                    }
                  ],
                  attrs: { flat: "" },
                  model: {
                    value: _vm.expandPanel,
                    callback: function($$v) {
                      _vm.expandPanel = $$v
                    },
                    expression: "expandPanel"
                  }
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        {
                          staticClass: "pa-0",
                          class: _vm.isMobile ? "mt-3" : "mt-6"
                        },
                        [_vm._v(" Rozšírené možnosti ")]
                      ),
                      _c(
                        "v-expansion-panel-content",
                        [
                          !_vm.jeTechnologia
                            ? [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "mobile-flex-direction",
                                    class: _vm.isMobile ? "mt-3" : "mt-6",
                                    attrs: { "no-gutters": "" }
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { md: "4", sm: "12" } },
                                      [
                                        _c("numeric-text-box", {
                                          key:
                                            "liw_filip__wiz_predmet__txt_objem_motora",
                                          ref: "objem_motora",
                                          attrs: {
                                            "data-id":
                                              "liw_filip__wiz_predmet__txt_objem_motora",
                                            cisloPredmetu: _vm.cisloPredmetu,
                                            decimalPlaces: 0,
                                            textRight: false
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "append",
                                                fn: function() {
                                                  return [
                                                    _vm._v("cm"),
                                                    _c(
                                                      "sup",
                                                      {
                                                        staticStyle: {
                                                          top: "-0.2em"
                                                        }
                                                      },
                                                      [_vm._v("3")]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            858059466
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { md: "4", sm: "12" } },
                                      [
                                        _c("numeric-text-box", {
                                          key:
                                            "liw_filip__wiz_predmet__txt_vykon_motora",
                                          ref: "vykon_motora",
                                          attrs: {
                                            "data-id":
                                              "liw_filip__wiz_predmet__txt_vykon_motora",
                                            cisloPredmetu: _vm.cisloPredmetu,
                                            suffix: "kW",
                                            decimalPlaces: 0,
                                            textRight: false
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { md: "4", sm: "12" } },
                                      [
                                        _c("numeric-text-box", {
                                          key:
                                            "liw_filip__wiz_predmet__txt_hmotnost_celkova",
                                          ref: "hmotnost_celkova",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet__txt_hmotnost_celkova",
                                            cisloPredmetu: _vm.cisloPredmetu,
                                            suffix: "kg",
                                            decimalPlaces: 0,
                                            textRight: false
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "mobile-flex-direction",
                                    attrs: { "no-gutters": "" }
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.isControlVisible(
                                              "pocet_naprav",
                                              "liw_filip__wiz_predmet__txt_pocet_naprav"
                                            ),
                                            expression:
                                              "isControlVisible('pocet_naprav','liw_filip__wiz_predmet__txt_pocet_naprav')"
                                          }
                                        ],
                                        attrs: { md: "4", sm: "12" }
                                      },
                                      [
                                        _c("numeric-text-box", {
                                          key:
                                            "liw_filip__wiz_predmet__txt_pocet_naprav",
                                          ref: "pocet_naprav",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet__txt_pocet_naprav",
                                            cisloPredmetu: _vm.cisloPredmetu,
                                            decimalPlaces: 0,
                                            textRight: false
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { md: "4", sm: "12" } },
                                      [
                                        _c("dynamic-combo", {
                                          key:
                                            "liw_filip__wiz_predmet__cb_typy_motora",
                                          ref: "typy_motora",
                                          attrs: {
                                            clearable: "",
                                            "data-id":
                                              "liw_filip__wiz_predmet__cb_typy_motora",
                                            cisloPredmetu: _vm.cisloPredmetu,
                                            outlined: ""
                                          },
                                          on: {
                                            valueChanged:
                                              _vm.onTypyMotoraValueChanged
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { md: "4", sm: "12" } },
                                      [
                                        _c("numeric-text-box", {
                                          key:
                                            "liw_filip__wiz_predmet__txt_pocet_sedadiel",
                                          ref: "pocet_sedadiel",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet__txt_pocet_sedadiel",
                                            cisloPredmetu: _vm.cisloPredmetu,
                                            decimalPlaces: 0,
                                            textRight: false
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "mobile-flex-direction",
                                    class: _vm.isMobile ? "mt-3" : "mt-6",
                                    attrs: { "no-gutters": "" }
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("text-box", {
                                          key:
                                            "liw_filip__wiz_predmet_tech__txt_vyrobca",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet_tech__txt_vyrobca",
                                            cisloPredmetu: _vm.cisloPredmetu
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      [
                                        _c("text-box", {
                                          key:
                                            "liw_filip__wiz_predmet_tech__txt_prislusenstvo",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet_tech__txt_prislusenstvo",
                                            cisloPredmetu: _vm.cisloPredmetu
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      [
                                        _c("dynamic-combo", {
                                          key:
                                            "liw_filip__wiz_predmet_tech__cb_krajina_povodu",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet_tech__cb_krajina_povodu",
                                            cisloPredmetu: _vm.cisloPredmetu
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "mobile-flex-direction",
                                    attrs: { "no-gutters": "" }
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("dynamic-combo", {
                                          key:
                                            "liw_filip__wiz_predmet_tech__cb_sposob_nadobudnutia",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet_tech__cb_sposob_nadobudnutia",
                                            cisloPredmetu: _vm.cisloPredmetu
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      [
                                        _c("check-box", {
                                          key:
                                            "liw_filip__wiz_predmet_tech__btn_tech_s_nehn",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet_tech__btn_tech_s_nehn",
                                            cisloPredmetu: _vm.cisloPredmetu
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      [
                                        _c("check-box", {
                                          key:
                                            "liw_filip__wiz_predmet_tech__btn_dovoz",
                                          attrs: {
                                            parentReloaded: _vm.reloaded,
                                            "data-id":
                                              "liw_filip__wiz_predmet_tech__btn_dovoz",
                                            cisloPredmetu: _vm.cisloPredmetu
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "predmet-form__cena" },
            [
              _c(
                "v-row",
                {
                  staticClass: "mobile-flex-direction",
                  attrs: { "no-gutters": "" }
                },
                [
                  _c(
                    "v-col",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "margin-left": "5px"
                      },
                      attrs: { cols: "12" }
                    },
                    [
                      _vm._v(" Cena "),
                      !!_vm.cenaTooltip
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { top: "", "max-width": "350" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "text-body-2 btn-help ml-2"
                                              },
                                              "v-icon",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_vm._v("mdi-help-circle")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3725339893
                              )
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.cenaTooltip))])]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      class: !_vm.isMobile ? "mt-12px" : "mt-6px",
                      attrs: { md: "4", sm: "12" }
                    },
                    [
                      _c("button-group", {
                        key: "liw_filip__wiz_predmet__btn_oc_s_dph",
                        ref: "oc_s_dph",
                        attrs: {
                          switchBtn: "",
                          small: "",
                          parentReloaded: _vm.reloaded,
                          "data-id": "liw_filip__wiz_predmet__btn_oc_s_dph",
                          cisloPredmetu: _vm.cisloPredmetu,
                          labelTooltip: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.nacitajCenaTooltip()
                          }
                        },
                        model: {
                          value: _vm.ocDph,
                          callback: function($$v) {
                            _vm.ocDph = $$v
                          },
                          expression: "ocDph"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                {
                  staticClass: "mobile-flex-direction",
                  class: !_vm.isMobile ? "mt-25px" : "mt-12px",
                  attrs: { "no-gutters": "" }
                },
                [
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isControlVisible(
                            "sadzba_dph",
                            "liw_filip__wiz_predmet__cb_sadzba_dph"
                          ),
                          expression:
                            "isControlVisible('sadzba_dph','liw_filip__wiz_predmet__cb_sadzba_dph')"
                        }
                      ],
                      attrs: { md: "4", sm: "12" }
                    },
                    [
                      _c("dynamic-combo", {
                        key: "liw_filip__wiz_predmet__cb_sadzba_dph",
                        ref: "sadzba_dph",
                        attrs: {
                          "data-id": "liw_filip__wiz_predmet__cb_sadzba_dph",
                          cisloPredmetu: _vm.cisloPredmetu,
                          stopMouseDown: ""
                        },
                        on: {
                          valueChanged: _vm.reloadDPH,
                          dataLoaded: function() {
                            return this$1.$refs.txtOCsDPH.loadData()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { md: "4", sm: "12" } },
                    [
                      _c("numeric-text-box", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ocDph === 0,
                            expression: "ocDph === 0"
                          }
                        ],
                        key: "liw_filip__wiz_predmet__txt_oc_s_dph",
                        ref: "txtOCsDPH",
                        attrs: {
                          placeholder: "0.00",
                          label: "Obstarávacia cena",
                          parentReloaded: _vm.reloaded,
                          "data-id": "liw_filip__wiz_predmet__txt_oc_s_dph",
                          cisloPredmetu: _vm.cisloPredmetu,
                          suffix: "€",
                          rules: [_vm.ocRule],
                          ignoreCompare: "",
                          stopMouseDown: ""
                        },
                        on: {
                          valueChanged: _vm.onTxtOCsDPHValueChanged,
                          dataLoaded: function() {
                            return this$1.$refs.txtOCbezDPH.loadData()
                          }
                        }
                      }),
                      _c("numeric-text-box", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ocDph === 1,
                            expression: "ocDph === 1"
                          }
                        ],
                        key: "liw_filip__wiz_predmet__txt_oc_bez_dph",
                        ref: "txtOCbezDPH",
                        attrs: {
                          placeholder: "0.00",
                          label: "OC bez DPH",
                          "data-id": "liw_filip__wiz_predmet__txt_oc_bez_dph",
                          cisloPredmetu: _vm.cisloPredmetu,
                          suffix: "€",
                          rules: [_vm.ocRule],
                          ignoreCompare: "",
                          stopMouseDown: ""
                        },
                        on: {
                          input: function(v) {
                            return (_vm.ocBezDphValue = v)
                          },
                          valueChanged: _vm.onTxtOCbezDPHValueChanged
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { md: "4", sm: "12" } },
                    [
                      _c("numeric-text-box", {
                        key: "liw_filip__wiz_predmet__txt_cennikova_cena",
                        ref: "cennikovaCena",
                        attrs: {
                          placeholder: "0.00",
                          "data-id":
                            "liw_filip__wiz_predmet__txt_cennikova_cena",
                          cisloPredmetu: _vm.cisloPredmetu,
                          label: "Cenníková cena",
                          suffix: "€",
                          stopMouseDown: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("text-box", {
            ref: "rokVyrobyAuto",
            attrs: {
              "v-show": false,
              "data-id": "liw_filip__wiz_predmet__txt_rok_vyroby",
              cisloPredmetu: _vm.cisloPredmetu
            }
          }),
          _c("numeric-text-box", {
            ref: "vekPredmetuAuto",
            attrs: {
              "v-show": false,
              "data-id": "liw_filip__wiz_predmet__txt_vek_predmetu",
              cisloPredmetu: _vm.cisloPredmetu,
              decimalPlaces: 0,
              textRight: false
            }
          }),
          _c(
            "v-dialog",
            {
              attrs: {
                value: _vm.vins.items.length > 0,
                "overlay-color": "#000",
                "overlay-opacity": "0.66",
                persistent: "",
                "max-width": "1000"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "d-flex justify-space-between" },
                    [
                      !_vm.isMobile
                        ? _c("h1", [_vm._v(" Vyberte si verziu modelu ")])
                        : _c("h3", [_vm._v(" Vyberte si verziu modelu ")]),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "auto" },
                          on: {
                            click: function($event) {
                              _vm.vins.items = []
                            }
                          }
                        },
                        [_vm._v("mdi-close")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      !_vm.isMobile
                        ? [
                            _c("v-data-table", {
                              staticClass: "standard-table row-pointer",
                              attrs: {
                                headers: _vm.vins.headers,
                                items: _vm.vins.items,
                                "disable-pagination": "",
                                "hide-default-footer": ""
                              },
                              on: { "click:row": _vm.selectVerziaModelu }
                            })
                          ]
                        : [
                            _c("span", {
                              staticClass: "f16 c-grayscale-100",
                              domProps: {
                                innerHTML: _vm._s(_vm.vins.errorText)
                              }
                            }),
                            _vm._l(_vm.vins.items, function(item, index) {
                              return _c(
                                "v-row",
                                {
                                  key: index,
                                  staticClass:
                                    "mobile-vyber-modelu-card d-flex flex-wrap mt-4",
                                  class: {
                                    "mobile-vyber-modelu-picked-card":
                                      item == _vm.vins.mobilePickedVehicleItem
                                  },
                                  attrs: { "no-gutters": "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.checkMobileVerziaModelu(item)
                                    }
                                  }
                                },
                                _vm._l(
                                  _vm.vins.headers.filter(function(h) {
                                    return (
                                      h.value !== "brand" && h.value !== "model"
                                    )
                                  }),
                                  function(header) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: header.value,
                                        staticClass: "pb-4",
                                        class: header.align,
                                        attrs: {
                                          cols: header.value == "nazov" ? 12 : 6
                                        }
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            class: {
                                              "mobile-vyber-modelu-picked-icon":
                                                header.value == "nazov" &&
                                                item ==
                                                  _vm.vins
                                                    .mobilePickedVehicleItem
                                            },
                                            attrs: { "no-gutters": "" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "f12 gs100" },
                                              [_vm._v(_vm._s(header.text))]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "f14 bold white100"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item[header.value])
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            })
                          ]
                    ],
                    2
                  ),
                  _vm.isMobile
                    ? _c("v-card-actions", { staticClass: "pt-0" }, [
                        _c(
                          "div",
                          { staticClass: "mobile-vyber-bottom-div" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-primary",
                                staticStyle: {
                                  width: "-webkit-fill-available"
                                },
                                attrs: {
                                  disabled: !_vm.vins.mobilePickedVehicleItem
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectVerziaModelu(
                                      _vm.vins.mobilePickedVehicleItem
                                    )
                                  }
                                }
                              },
                              [_vm._v(" Potvrdiť ")]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("message-box", {
            attrs: {
              title: _vm.warningMessage.title,
              text: _vm.warningMessage.text,
              action: _vm.warningMessage.action,
              persistent: "",
              "hide-cancel": ""
            },
            model: {
              value: _vm.warningMessage.open,
              callback: function($$v) {
                _vm.$set(_vm.warningMessage, "open", $$v)
              },
              expression: "warningMessage.open"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }